export interface AreaGeometryResponseDto {
  type: string;
  coordinates: object;
}